import { render, staticRenderFns } from "./CourseFormV2.vue?vue&type=template&id=82c4bdae&"
import script from "./CourseFormV2.vue?vue&type=script&lang=ts&"
export * from "./CourseFormV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports